import { clsx, type ClassValue } from 'clsx'
import { extendTailwindMerge } from 'tailwind-merge'

// The motion scale in globals.css adds named duration/ease values. Without
// these, tailwind-merge treats `duration-fast` as an unknown class and stops
// deduping duration/ease conflicts — so a caller overriding a primitive's
// timing via className would silently lose to stylesheet order.
const twMerge = extendTailwindMerge({
  extend: {
    classGroups: {
      duration: [{ duration: ['quick', 'fast', 'medium', 'slow'] }],
      ease: [{ ease: ['smooth-out'] }],
    },
  },
})

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export function titleCase(value: string): string {
  return value
    .replaceAll('_', ' ')
    .split(' ')
    .filter(Boolean)
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ')
}
